"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var view_models_1 = require("./../view-models");
var view_config_models_1 = require("./../view-config-models");
var validators_1 = require("./../validators");
var blocked_provider_helper_1 = require("./../blocked-provider.helper");
var OptionalCoverageComponent = (function () {
    function OptionalCoverageComponent() {
        this.blockedProvidersClicked = new core_1.EventEmitter();
    }
    OptionalCoverageComponent.prototype.shouldShowLimits = function () {
        if (this.coverageFormGroup.controls['selected'].value && this.coverage.limits && this.coverage.limits.length > 1 && !this.editCoverageDisabled()) {
            return true;
        }
        else {
            return false;
        }
    };
    OptionalCoverageComponent.prototype.editCoverageDisabled = function () {
        return !this.coverage.canRemoveCoverage;
    };
    OptionalCoverageComponent.prototype.shouldShowCRCC = function () {
        if (this.coverageFormGroup.controls['selected'].value && this.isCRCC()) {
            return true;
        }
        else {
            return false;
        }
    };
    OptionalCoverageComponent.prototype.isCRCC = function () {
        return Boolean(this.coverageFormGroup.controls['carRentalCompany']);
    };
    OptionalCoverageComponent.prototype.requiresRequote = function () {
        return this.coverage.ratingId === validators_1.Constants.COVERAGE_CFAR && this.requoteCFAR;
    };
    OptionalCoverageComponent.prototype.onBlockedProviderLinkClicked = function () {
        this.blockedProvidersClicked.emit();
    };
    OptionalCoverageComponent.prototype.showEventLink = function () {
        return blocked_provider_helper_1.BlockedProviderHelper.showEventLink(this.baseUrl);
    };
    OptionalCoverageComponent.prototype.showHrefLink = function () {
        return blocked_provider_helper_1.BlockedProviderHelper.showHrefLink(this.baseUrl);
    };
    OptionalCoverageComponent.prototype.getBlockedProviderUrl = function () {
        return blocked_provider_helper_1.BlockedProviderHelper.getBlockedProviderUrl(this.baseUrl);
    };
    return OptionalCoverageComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", view_models_1.CoverageViewModel)
], OptionalCoverageComponent.prototype, "coverage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.FormGroup)
], OptionalCoverageComponent.prototype, "coverageFormGroup", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", view_config_models_1.CoverageViewConfig)
], OptionalCoverageComponent.prototype, "formConfiguration", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], OptionalCoverageComponent.prototype, "quoting", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], OptionalCoverageComponent.prototype, "submitted", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], OptionalCoverageComponent.prototype, "requoteCFAR", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], OptionalCoverageComponent.prototype, "showBlockedProviders", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], OptionalCoverageComponent.prototype, "baseUrl", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], OptionalCoverageComponent.prototype, "blockedProvidersClicked", void 0);
OptionalCoverageComponent = __decorate([
    core_1.Component({
        selector: 'optional-coverage',
        template: "<div *ngIf=\"coverageFormGroup\" [formGroup]=\"coverageFormGroup\">     <div class=\"row edit-coverage-display-name\">         <span class=\"col-xs-8\">             <input type=\"checkbox\"                    formControlName=\"selected\"                    class=\"edit-selection-box\"                    [attr.disabled]=\"editCoverageDisabled() ? true : null\" />             {{coverage.name}}             <span *ngIf=\"isCRCC() && showBlockedProviders\">                 <a [href]=\"getBlockedProviderUrl()\" [hidden]=\"!showHrefLink()\"  target=\"_blank\">(View Blocked Providers)</a>                 <a href=\"javascript:void(0)\" [hidden]=\"!showEventLink()\" (click)=\"onBlockedProviderLinkClicked($event)\">(View Blocked Providers)</a>             </span>         </span>         <span class=\"col-xs-4 text-right nopadding\" *ngIf=\"!quoting || !shouldShowLimits()\">{{coverage.coverageLimitDisplayText}}</span><span class=\"col-xs-4 text-right nopadding\" *ngIf=\"quoting == true && shouldShowLimits()\"><i class=\"fa fa-spinner fa-spin fa-pulse coveragePayoutSpinner\"></i></span>         <div class=\"col-md-6\" *ngIf=\"shouldShowLimits()\">             <select class=\"form-control\"                     formControlName=\"limitSelection\">                 <option *ngFor=\"let limit of coverage.limits\" [value]=\"limit\" [selected]=\"coverage.coverageLimit === limit\">                     {{limit | currency:'USD':true:'1.0-0'}}                 </option>             </select>         </div>     </div>     <div class=\"row-fluid\">         <div *ngIf=\"shouldShowCRCC()\">             <date-pair [date1Label]=\"formConfiguration.date1Label\"                        [date2Label]=\"formConfiguration.date2Label\"                        [date1FormControlName]=\"formConfiguration.date1FormControlName\"                        [date2FormControlName]=\"formConfiguration.date2FormControlName\"                        [form]=\"coverageFormGroup\"                        [date1MaxDate]=\"formConfiguration.tripReturnDate\"                        [date1MinDate]=\"formConfiguration.tripDepartureDate\"                        [date2MaxDate]=\"formConfiguration.tripReturnDate\"                        [date2MinDate]=\"formConfiguration.tripDepartureDate\"                        [submitted]=\"submitted\">             </date-pair>             <div class=\"form-group col-md-4\">                 <label>Car Rental Company</label>                 <typeahead-car-rental formControlName=\"carRentalCompany\" [placeHolder]=\"typeaheadPlaceholder\"></typeahead-car-rental>             </div>         </div>     </div>      <!-- TO DO Move to Angular 2 Component Or Downgrade Component -->     <!--<view-acknowledgements class=\"col-xs-12\"                            acknowledgements=\"coverage.acknowledgements\"                            ng-if=\"coverage.acknowledgements && coverage.acknowledgements.length > 0\">     </view-acknowledgements>--> </div>"
    }),
    __metadata("design:paramtypes", [])
], OptionalCoverageComponent);
exports.OptionalCoverageComponent = OptionalCoverageComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/coverages/optional-coverage.component.js